// extracted by mini-css-extract-plugin
export var closed = "ExpandingText-module--closed--06513";
export var moreButton = "ExpandingText-module--moreButton--d1081";
export var open = "ExpandingText-module--open--69bdf";
export var text = "ExpandingText-module--text--60630";